import React, { useEffect } from "react";
import BookmarkDetailPageSidebar from "./bookmark-detail-page-sidebar";
import { Icons } from "atoms/constants/icons";
import SortBy from "../../options/sort-by";
import useSortBookmarks from "utilities/hooks/domain/my-link/use-sort-bookmarks";
import useSearchBookmarks from "utilities/hooks/domain/my-link/use-search-bookmarks";
import SearchBookmarks from "../../options/search-bookmarks";
import usePagedResultsFromParams from "utilities/hooks/use-paged-results-from-params";
import { useParams } from "react-router";
import { BookmarkPaginationSettings } from "constants/bookmark-pagination-constants";
import { BookmarkUtils } from "utilities/bookmark-utils";
import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import useBookmarksByColorQuery from "utilities/hooks/queries/my-link/bookmarks/sidebars/use-bookmarks-by-color-query";
import { UserBookmarkColors } from "utilities/enumerations/user-bookmark-colors";
import useFilterBookmarks from "utilities/hooks/domain/my-link/use-filter-bookmarks";
import FilterByShareStatus from "../../options/filter-by-share-status";
import UserBookmarkShareFilterOption from "models/enumerations/filtering/user-bookmarks/user-bookmark-share-filter-option";

const SidebarForColors = () => {
    const { groupId } = useParams<{ groupId: string; id: string }>();

    const { sortBy, onSortByChange } = useSortBookmarks(
        UserBookmarkCountBy.Color
    );
    const { searchText, onSearchTextChange } = useSearchBookmarks(
        UserBookmarkCountBy.Color
    );
    const { onShareFilterChange, shareFilter } = useFilterBookmarks(
        UserBookmarkCountBy.Color
    );
    const { skip, take, onSetPage, currentPage, numberOfPages, setRowCount } =
        usePagedResultsFromParams(
            BookmarkPaginationSettings.SidebarTake,
            BookmarkUtils.buildGroupedParam(UserBookmarkCountBy.Color, groupId)
        );

    const { bookmarks } = useBookmarksByColorQuery({
        searchText,
        skip,
        take,
        sortBy,
        currentUserOnly:
            shareFilter === UserBookmarkShareFilterOption.PrivateOnly,
    });

    useEffect(() => {
        if (bookmarks?.bookmarksLength) {
            setRowCount(bookmarks?.bookmarksLength);
        }
    }, [bookmarks?.bookmarksLength, setRowCount]);

    return (
        <BookmarkDetailPageSidebar
            totalPages={numberOfPages}
            onSetPage={onSetPage}
            currentPage={currentPage}
            bookmarks={bookmarks?.bookmarks}
            headingText={UserBookmarkColors[groupId]}
            headingIcon={Icons.Bookmark}
            dropdowns={
                <>
                    <SortBy sort={sortBy} onChange={onSortByChange} />
                    <FilterByShareStatus
                        shareStatus={shareFilter}
                        onChange={onShareFilterChange}
                    />
                    <SearchBookmarks
                        searchText={searchText}
                        onChange={onSearchTextChange}
                    />
                </>
            }
        />
    );
};
export default SidebarForColors;
